export default "__VITE_ASSET__DFJeBIN1__ 400w, __VITE_ASSET__DADxqjkz__ 800w, __VITE_ASSET__DPpKFh4h__ 1024w";